



































































import env from '@/env';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Environment } from '@/types';

@Component({})
export default class SelectEnvironmentDialog extends Vue {
  @Prop({ default: () => -1 })
  cutoverplan_id!: number;

  @Prop({ default: () => [] })
  environments!: Environment[];

  @Prop({ default: () => 'download' })
  context?: 'download' | 'hash';

  backend_url = '';

  dialog = false;

  debug = false;

  async created() {
    this.backend_url = env.backend_url;
  }
}
